<section class="home-banner-bg seciton-bg-1 text-center d-flex align-items-start"
  [ngClass]="{ 'stripMarginAdded': stripMargin,'subscribe-strip-margin-home':  shouldShowTrialBanner }"
  id="tender_location">

  <div class="container ">
    <h1>
      Easily discover relevant government <span class="txt-red">tenders</span>
    </h1>
    <h2>Search from over 80 lac tenders across India</h2>

    <!--Search Bar Start From Here-->
    <app-search-bar [display]="'mainSearch'"></app-search-bar>
    <!--Search Bar End Here-->
  </div>
</section>

<section class="features counter-section seciton-bg-1 pb-60">
  <div class="container d-flex justify-content-center">
    <div class="row justify-content-center w-100">
      <div class="col-sm-8">
        <div class="row counter-width">
          <div class="col-lg-12">
            <div class="row">
              <div class="col-sm-4 col-4">
                <div class="card card-10">
                  <div class="card-body">
                    <span>{{ counts?.activeTenders }}</span>
                    <p>Active Tenders</p>
                  </div>
                </div>
              </div>
              <div class="col-sm-4 col-4">
                <div class="card card-10">
                  <div class="card-body">
                    <span>{{ counts?.tendersOpeningToday }}</span>
                    <p class="d-none d-lg-block">Tenders Opening Today</p>
                    <p class="d-block d-lg-none">Opening Today</p>
                  </div>
                </div>
              </div>
              <div class="col-sm-4 col-4">
                <div class="card card-10">
                  <div class="card-body">
                    <span>{{ counts?.tendersClosingToday }}</span>
                    <p class="d-none d-lg-block">Tenders Closing Today</p>
                    <p class="d-block d-lg-none">Closing Today</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="check-points-section">
  <div class="container d-flex justify-content-center">
    <div class="row checkbox-points-features">
      <div class="col-sm-4 col-4 h-100">
        <span>
          <i class="sprite-img green-check"></i> No Keyword Restriction</span>
      </div>
      <div class="col-sm-4 col-4 h-100">
        <span>
          <i class="sprite-img green-check"></i> No Credit Card Required</span>
      </div>
      <div class="col-sm-4 col-4 h-100">
        <span>
          <i class="sprite-img green-check"></i> Free Trial for 5 Days</span>
      </div>
    </div>
  </div>
</section>

<section class="high-value-tenders pt-100" id="keyword_value_tenders">
  <app-explore-by-keywords></app-explore-by-keywords>
</section>

<section class="latest-tender-alert-section pt-100">
  <div class="container">
    <div class="latest-tender-alert" (click)="onDivClick($event)">
      <div class="row">
        <div class="col-sm-5">
          <h4>Get Relevant & Latest <br> Tender Alerts</h4>
          <p *ngIf="showInputs" [@toggle]="showInputs ? 'visible' : 'hidden'">Share your details and always get update
            on latest tender and news</p>
          <ul *ngIf="showInputs" [@toggle]="showInputs ? 'visible' : 'hidden'" class="latest-tender-alerts-features">
            <li><i class="sprite-img form_search_icon"></i> Keyword & Category Searches</li>
            <li><i class="sprite-img form_bell_icon"></i> Tender Alerts on Email, SMS & WhatsApp</li>
            <li><i class="sprite-img form_download_icon"></i> Tender Document Downloads</li>
          </ul>
        </div>
        <div class="col-sm-7">
          <div class="form-card">
            <h5 *ngIf="showInputs" [@toggle]="showInputs ? 'visible' : 'hidden'"><span class="red-text"> (*) </span>
              Marked fields are mandatory</h5>

            <form [formGroup]="leadForm" (ngSubmit)="onSubmit()">
              <div class="row">
                <div class="col-6 col-sm-6">
                  <input type="text" class="form-control" formControlName="businessName" (focus)="showAllInputs()"
                    placeholder="Business Name*" maxlength="50">
                  <div *ngIf="leadForm.get('businessName')?.errors?.['maxlength']">
                    <small class="text-danger">Business Name cannot exceed 50 characters.</small>
                  </div>
                  <div *ngIf="leadForm.get('businessName')?.errors?.['noNumbers']">
                    <small class="text-danger">Business Name cannot contain numbers.</small>
                  </div>
                </div>
                <div class="col-6 col-sm-6">
                  <input type="text" class="form-control" formControlName="phone" (focus)="showAllInputs()"
                    placeholder="Mobile No.*" maxlength="10">
                  <div *ngIf="leadForm.get('phone')?.errors?.['pattern']">
                    <small class="text-danger">Phone number must be exactly 10 digits.</small>
                  </div>
                </div>
                <div class="col-6 col-sm-6 mb-30 mt-15" *ngIf="showInputs"
                  [@toggle]="showInputs ? 'visible' : 'hidden'">
                  <input type="text" class="form-control" formControlName="gstNum" placeholder="Company GST*"
                    maxlength="15">
                  <div *ngIf="leadForm.get('gstNum')?.errors?.['maxlength']">
                    <small class="text-danger">GST Number cannot exceed 15 characters.</small>
                  </div>
                </div>
                <div class="col-6 col-sm-6 mb-30 mt-15" *ngIf="showInputs"
                  [@toggle]="showInputs ? 'visible' : 'hidden'">
                  <input type="text" class="form-control" formControlName="name" placeholder="Name" maxlength="100">
                  <div *ngIf="leadForm.get('name')?.errors?.['maxlength']">
                    <small class="text-danger">Name cannot exceed 100 characters.</small>
                  </div>
                  <div *ngIf="leadForm.get('name')?.errors?.['noNumbers']">
                    <small class="text-danger">Name cannot contain numbers.</small>
                  </div>
                </div>
                <div class="col-md-6 col-sm-6 mb-50" *ngIf="showInputs" [@toggle]="showInputs ? 'visible' : 'hidden'">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" formControlName="updatesOnWhatsapp">
                    <label class="form-check-label" for="flexCheckDefault">
                      Get updates on WhatsApp <i class="sprite-img-list whatsapp-icon-green whatsapp-icon"></i>
                    </label>
                  </div>
                </div>
                <div class="col-sm-6 mb-50" *ngIf="showInputs" [@toggle]="showInputs ? 'visible' : 'hidden'">
                  <button type="submit" class="btn btn-danger w-100" [disabled]="leadForm.invalid">Submit
                    Details</button>
                </div>
              </div>
              <p *ngIf="showInputs" [@toggle]="showInputs ? 'visible' : 'hidden'">The personal data shared by you will
                be used by Moglix Tenders to connect with you directly or through its affiliates and partners.</p>
              <p *ngIf="showInputs" [@toggle]="showInputs ? 'visible' : 'hidden'">The personal data (Full Name and Email
                Id) provided by you will be used by Moglix Tenders to connect with you for arranging the demo.</p>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="pt-100" *ngIf="!isWebView">
  <div class="container">
    <a href="https://play.google.com/store/apps/details?id=com.moglix.tender&hl=en" target="_blank">
      <img class="img-fluid d-none d-lg-block w-100" *ngIf="isMobile" src="./assets/images/AppRecommendationBanner.webp"
        alt="Download TenderShark Mobile App">
      <img class="img-fluid d-block d-lg-none w-100" src="./assets/images/AppRecommendationBannerMobile.webp"
        alt="Download TenderShark Mobile App">
    </a>
  </div>
</section>

<section class="tender-closing-soon pt-100 section-bg-1" id="authority_tender">
  <app-explore-by-authority></app-explore-by-authority>
</section>

<section class="fresh-bid-tenders pt-100" id="state_tenders">
  <app-explore-by-states></app-explore-by-states>
</section>

<!-- Newly added -->
<ng-container>
  <app-newly-added-tenders></app-newly-added-tenders>
</ng-container>

<section class="features pt-100">
  <div class="container d-flex">
    <div class="row">
      <div class="col-lg-4">
        <p class="section-heading-2">
          Solutions to expand your <span class="txt-red"> business. </span>
        </p>
        <p class="section-sub-heading-2 business-solution-heading">
          Maximize your time on securing contracts, not hunting for them –
          ensure you catch every relevant tender.
        </p>
      </div>
      <div class="col-lg-8">
        <div class="row">
          <div class="col-md-4 col-sm-12 ">
            <div class="card card-7 business-solution-card card-purple">
              <div class="card-body text-center">
                <div class="sprite-img supplier-central-logo mb-30 mx-auto"></div>
                <span class="solution-card-heading">Register as Supplier on Moglix</span>
                <p>
                  Register and grow your business with one of the top B2B selling platforms online.
                </p>
                <a href="https://supplier.moglix.com/?utm_source=tendershark&utm_medium=homepage&utm_campaign=promotion"
                  target="_blank" rel="noopener noreferrer"
                  class="btn btn-outline-danger card-view-more view-more-small">
                  View More
                  <i class="arrow-right-red-3 sprite-img d-inline d-lg-none"></i>
                </a>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-12">
            <div class="card card-7 business-solution-card card-orange">
              <div class="card-body text-center">
                <div class="sprite-img moglix-business-logo mb-30 mx-auto"></div>
                <span class="solution-card-heading">Expand your business</span>
                <p>
                  Our matchmaking services help you find the potential partners,
                  buyers, financiers
                </p>
                <a href="https://business.moglix.com/?utm_source=tendershark&utm_medium=homepage&utm_campaign=promotion"
                  target="_blank" rel="noopener noreferrer"
                  class="btn btn-outline-danger card-view-more view-more-small">
                  View More
                  <i class="arrow-right-red-3 sprite-img d-inline d-lg-none"></i>
                </a>

              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-12">
            <div class="card card-7 business-solution-card card-skyBlue">
              <div class="card-body text-center">
                <div class="sprite-img credlix-logo mb-30 mx-auto"></div>

                <span class="solution-card-heading">Working Capital Financing</span>
                <p>
                  Get instant access to unsecured loans of upto 5 crores and get
                  started with your project
                </p>
                <a href=" https://www.credlix.com/?utm_source=tendershark&utm_medium=homepage&utm_campaign=promotion"
                  target="_blank" rel="noopener noreferrer"
                  class="btn btn-outline-danger card-view-more view-more-small">
                  View More
                  <i class="arrow-right-red-3 sprite-img d-inline d-lg-none"></i>
                </a>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="pt-100">
  <div class="container d-flex justify-content-center">
    <div class="group-info-strip">
      <div class="group-info-heading">
        <p>We are part of the $2.6bn Moglix group</p>
      </div>
      <div class="group-info-img">
        <img src="{{imageBasePath}}logo/moglix-logo.webp" loading="eager" alt="Moglix Logo" />
      </div>
    </div>
  </div>
</section>

<section class="features pt-100 pb-100">
  <div class="container text-center">
    <h3 class="section-heading-2 mb-40">
      Apply our innovative technology to take your <br />
      business to the next stage of growth.
    </h3>

    <div class="row justify-content-center">
      <div class="col-xl-3 col-6 mb-15">
        <div class="card card-7 h-100">
          <div class="card-body text-start">
            <div class="sprite-img card-7-image access-document mb-30"></div>
            <span class="solution-card-heading">Access documents effortlessly</span>
            <p>
              Download all documents, including Tender Notice, NIT, AOC, BOQ,
              and more free of cost
            </p>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-6 mb-15">
        <div class="card card-7 h-100">
          <div class="card-body text-start">
            <div class="sprite-img card-7-image msg-mobile mb-30"></div>
            <span class="solution-card-heading">Stay updated with the change notifications.</span>
            <p>
              Follow the tender to receive updates on schedule changes,
              modifications, and outcomes.
            </p>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-6 mb-15">
        <div class="card card-7 h-100">
          <div class="card-body text-start">
            <div class="sprite-img card-7-image bell-icon mb-30"></div>
            <span class="solution-card-heading">Enhance efficiency with automated searches.</span>
            <p>
              Set your preferred keywords, location, and authority to get daily
              notifications.
            </p>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-6 mb-15">
        <div class="card card-7 h-100">
          <div class="card-body text-start">
            <div class="sprite-img card-7-image search-document mb-30"></div>
            <span class="solution-card-heading">Experience ease in searching tenders.</span>
            <p>
              Enjoy limitless searches within tenders, results, and BOQ
              documents.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="features pb-100">
  <div class="container text-center">
    <h4 class="section-heading-2 mb-p5">TenderShark Blogs</h4>
    <h6 class="section-sub-heading-2 mb-30"> Your Daily Dose of Tender News</h6>
    <div class="blog-list-slider w-100"
      [ngClass]="{'with-scroll-container': isScroll, 'without-scroll-container': !isScroll}">
      <div [id]="containerId" id="{{containerId}}" class="inner-container" (scroll)="onSliderScroll($event)"
        [class.top-performing-inner-container]="topPerformingContainer">
        <div *ngFor="let item of blogList">
          <div class="card card-11  box-shadow-unset h-100 cursor" routerLink="/blogs/{{item?.slug}}">
            <div class="card-header">
              <img *ngIf="item?.imageLink" [src]="item?.imageLink" [alt]="item?.title + ' - TenderShark'"
                class="main-img">
              <!-- <img *ngIf="item?.imageLink" loading="eager" [src]="item.imageLink" width="295px" height="135px"
              alt={{item.title}} class="main-img" loading="lazy"> -->
            </div>
            <div class="card-body text-start">
              <span class="date">{{item?.date | date:"MMM dd, YYYY"}}</span>
              <a class="blog-card-title" href="{{baseUrl + '/blogs/'+ item?.slug}}">{{item?.title}}</a>
              <span class="read-more-cta" routerLink="/blogs/{{item.slug}}">Read More<i
                  class="sprite-img blue-arrow-right"></i></span>
            </div>
          </div>
        </div>
        <span class="left-arrow arrow" *ngIf="isLeftVisible" (click)="scrollSliderDiv(false)"
          [class.hide-arrow-div]="hideContainer">
          <i class="sprite-img icon-back "></i>
        </span>
        <span class="right-arrow arrow" *ngIf="isRightVisible" (click)="scrollSliderDiv(true)"
          [class.hide-arrow-div]="hideContainer">
          <i class="sprite-img icon-next cursor "></i>
        </span>
      </div>
    </div>
  </div>
</section>

<div class="container">
  <app-faq-listing-page [faqId]="'Homepage'"></app-faq-listing-page>
</div>


<app-keywords-section></app-keywords-section>
<app-thankyou-modal *ngIf="isBrowser" ></app-thankyou-modal>